export default "__VITE_ASSET__CthlPDyI__"